import type { CartSimulationEntry, CartSimulationRequest, CartSimulationResponseItem } from "~/domains/cart/types";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "~/domains/cart/utils/cartResourceIdentity";

type SimulationResponseDTO = {
  results?: CartSimulationResponseItem[];
  quantityAdjusted: boolean;
};

export async function simulateCart(entries: CartSimulationEntry[], signal?: AbortSignal) {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cart simulation requires an Active Cart");
  }

  const body: CartSimulationRequest = {
    items: entries,
  };

  const response = await occFetch(
    occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/add-to-cart/simulation`),
    {
      body: JSON.stringify(body),
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      signal,
    },
  );

  if (!response.ok) {
    throw new Error(`Cart simulate failed with status ${response.status}`);
  }

  const dto = (await response.json()) as SimulationResponseDTO;
  return {
    ...dto,
    results: dto.results ?? [],
  };
}
